import React from "react";
import {
    Document,
    Page,
    StyleSheet,
    PDFViewer,
    View,
    Font,
} from "@react-pdf/renderer";
import {PdfElementComponent} from "./PdfElementComponent";
import {PdfElementConfig} from "./_models";

Font.register({
    family: "Roboto",
    src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-light-webfont.ttf"
});

const styles = StyleSheet.create({
    page: {
        backgroundColor: "#ffffff",
        color: "#000000",
        fontFamily: "Roboto"
    },
    viewer: {
        width: '100%',
        height: '600px',
    },
    container: {
        paddingTop: '20px',
        paddingBottom: '20px',
        paddingLeft: '40px',
        paddingRight: '40px',
    }
});

type Props = {
    contents: PdfElementConfig[]
}
export function PdfRendererComponent({contents}: Props) {
    return (
        <PDFViewer style={styles.viewer}>
            <Document>
                <Page size="A4" style={styles.page}>
                    <View style={styles.container}>
                        {contents.map(el => <PdfElementComponent config={el}/>)}
                    </View>
                </Page>
            </Document>
        </PDFViewer>
    )
}